import { Fragment } from "react";
import { styled } from "@mui/material/styles";
import { TypographyH1, TypographyH2 } from "../assets/typographyTheme";

const CustomBold = styled('span')`
    font-family: 'Aeonik Bold', 'Arial';
`;
const CustomParagraph = styled('p')`
   line-height:22px;
`;
const CustomList = styled('ul')(({ theme: { breakpoints } }) => `
  list-style-type: initial;
  margin-left: 20px;
  font-family: 'Aeonik Regular';
  ${[breakpoints.down('sm')]} {
    margin-top: 24px;
    margin-bottom: 30px;
  }
`);

const renderNode = (node) => {
  if (!node) return null;

  switch (node.nodeType) {
    case "document":
      return node.content.map((child, index) => <Fragment key={index}>{renderNode(child)}</Fragment>);

    case "paragraph":
      return (
        <CustomParagraph>
          {node?.content?.[0]?.value === "" && node?.content?.[0]?.nodeType === "text" ? <br /> : node.content.map((child, index) => renderNode(child))}
        </CustomParagraph>
      );

    case "heading-1":
      return <TypographyH1>{node.content.map((child, index) => renderNode(child))}</TypographyH1>;

    case "heading-2":
      return <TypographyH2>{node.content.map((child, index) => renderNode(child))}</TypographyH2>;

    case "unordered-list":
      return <CustomList>{node.content.map((child, index) => renderNode(child))}</CustomList>;

    case "ordered-list":
      return <ol>{node.content.map((child, index) => renderNode(child))}</ol>;

    case "list-item":
      return <li>{node.content.map((child, index) => renderNode(child))}</li>;

    case "embedded-asset-block":
      const { title, file } = node.data.target.fields;
      return <img src={file.url} alt={title} style={{ maxWidth: "100%" }} />;

    case "text":
      const isBold = node.marks?.some((mark) => mark.type === "bold");
      return isBold ? <CustomBold>{node.value}</CustomBold> : node.value;
    
    case "hyperlink":
      return <a href={node.data.uri} style={{ textDecoration: "none", margin: "0 4px" }}>{node.content[0].value}</a>

    default:
      return <span>{node.content?.map((child, index) => renderNode(child))}</span>;
  }
};

const CustomRichTextRenderer = ({ jsonData }) => {
  return <div>{renderNode(jsonData)}</div>;
};

export default CustomRichTextRenderer;
